export const LOAD_FLOW_LIST_OPTIONS = 'LOAD_FLOW_LIST_OPTIONS';
export const ON_REPORT_VIEW_EXIT = 'ON_REPORT_VIEW_EXIT';
